var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"playbook-rule"},[(_vm.userHasRule)?_c('playbooks-svg-available'):_c('playbooks-svg-unavailable'),_c('span',[_vm._v(_vm._s(_vm.ruleText)),(!_vm.userHasRule)?_c('span',{staticClass:"unavailable"},[_vm._v("(Not available in your plan)")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }